<template>
  <b-pagination
    v-if="showPagination"
    v-model="activePage"
    :total-rows="totalRows"
    :per-page="perPage"
    :aria-controls="tableId"
    class="i-pagination"
    @input="handlePageChange"
  >
    <template #first-text
      ><span class="chevron">
        <i-icon symbol="medium-chevron-left-double" :size="20"></i-icon></span
    ></template>
    <template #prev-text>
      <span class="chevron">
        <i-icon symbol="medium-chevron-left" :size="20"></i-icon>
      </span>
    </template>
    <template #next-text>
      <span class="chevron">
        <i-icon symbol="medium-chevron-right" :size="20"></i-icon>
      </span>
    </template>
    <template #last-text>
      <span class="chevron">
        <i-icon symbol="medium-chevron-right-double" :size="20"></i-icon>
      </span>
    </template>
  </b-pagination>
</template>

<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: {
    'i-icon': iIcon,
  },
  props: {
    tableId: {
      default: '',
      type: String,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    perPage: {
      default: undefined,
      type: Number,
    },
    totalRows: {
      default: undefined,
      type: Number,
    },
  },
  data() {
    return {
      activePage: this.currentPage,
    };
  },
  computed: {
    showPagination() {
      return this.totalRows > this.perPage;
    },
  },
  methods: {
    handlePageChange() {
      this.$emit('page-change', this.activePage);
    },
  },
};
</script>
